import Phaser from 'phaser';

export class Tooltip extends Phaser.GameObjects.Container {
    private background: Phaser.GameObjects.Rectangle;
    private text: Phaser.GameObjects.Text;
    
    constructor(scene: Phaser.Scene) {
        super(scene, 0, 0);
        
        // Create background
        this.background = scene.add.rectangle(0, 0, 200, 30, 0x000000, 0.8);
        this.background.setOrigin(0, 0);
        
        // Create text
        this.text = scene.add.text(10, 5, '', {
            fontSize: '14px',
            color: '#ffffff',
            fontFamily: 'Arial'
        });
        
        // Add to container
        this.add([this.background, this.text]);
        
        // Set container properties
        this.setVisible(false);
        
        // NOTE: We don't add to scene here anymore, as it will be added to the uiContainer in ProtocellScene
        // scene.add.existing(this);
        console.log('Tooltip created');
        
        // Set depth to ensure tooltip is above everything
        this.setDepth(9999);
        
        // Make sure the tooltip doesn't interfere with input
        this.disableInteractive();
    }
    
    public show(x: number, y: number, content: string): void {
        this.text.setText(content);
        
        // Adjust background width based on text width
        const padding = 20;
        this.background.width = this.text.width + padding;
        this.background.height = this.text.height + padding;
        
        // Position tooltip above the cursor
        this.setPosition(x, y - this.background.height - 10);
        
        // Make sure tooltip stays within screen bounds
        const screenWidth = this.scene.scale.width;
        if (this.x + this.background.width > screenWidth) {
            this.x = screenWidth - this.background.width;
        }
        
        // Ensure tooltip is fully visible
        this.setVisible(true);
        
        // Depth is already set in constructor, no need to set it again
        // this.setDepth(9999);
        
        console.log('Tooltip displayed at:', x, y, 'with content:', content);
    }
    
    public hide(): void {
        this.setVisible(false);
    }
} 